import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { InfiniteData } from '@tanstack/react-query';
import { Route } from '../../../../domain/route/Route';

export const getUnfinishedRoutesMutationKey = () => [`unfinished_routes`];

export const getRoutesQueryKey = () => [`route_list`];
export type RoutesQueryType = InfiniteData<PaginatedResult<Route>>;
